export let dir = { rootDir: '' };


// WEBPACK FOOTER //
// ./src/root-dir.ts